import styled from "styled-components";

const PhoneLoginPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;

  a {
    font-size: 14px;
  }

  .formsLayout .center .form {
    margin: 30px;
  }
`;

export default PhoneLoginPageDisplay;
